import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import React, {useEffect, useState} from "react";
import {Auth} from "@aws-amplify/auth";
import { useHistory } from "react-router-dom";
import ApiService from "../../ApiService";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import InputGroup from "react-bootstrap/InputGroup"
import FormControl from "react-bootstrap/FormControl"
import moment from "moment";
import removeClass from "../../util/RemoveCSS";
import MaterialTable from 'material-table';
import { NoteAdd, Message, AssignmentInd, AssignmentReturned } from "@material-ui/icons";
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import PatientProfileModal from "../PatientProfileModal";
import {validClinicianLicenseStates, hideRelevantInfo} from '../../util/licence-util';
import {
    format_yyyy_mm_dd_to_DATETIME_MED,
    formatUSMobileNum,
    getAgeInYrsMonthsDisplay,
    getRegion
} from "../../util/common";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const UserResult = () => {
    const classes = useStyles();

    const [token, setToken] = useState(null);
    const [assignedTestResults, setAssignedTestResults] = useState([]);
    const [clinicianId, setClinicianId] = useState(null);
    // const [clinicianState, setClinicianState] = useState(null);
    const [clinicianValidStates, setClinicianValidStates] = useState([]);
    const [customerId, setCustomerId] = useState(null);
    const [showExternal, setShowExternal] = useState(null);
    const [showInternal, setShowInternal] = useState(null);
    const [showAddressDetails, setShowAddressDetails] = useState(null);
    const [noteKitId, setNoteKitId] = useState(null);
    const [noteText, setNoteText] = useState(null);
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [backdropOpen, setBackdropOpen] = useState(false);
    const [snackOpen, setSnackOpen] = useState(false);
    const [snackText, setSnackText] = useState('');
    const [snackSeverity, setSnackSeverity] = useState('');
    const [selectedPatient, setSelectedPatient] = useState({ address: {} });


    const handleSnackOpen = (text, severity) => {
        setSnackSeverity(severity)
        setSnackText(text)
        setSnackOpen(true);
    };
    
    const handleSnackClose = () => {
        setSnackOpen(false);
    };

    let history = useHistory();

    removeClass();

    useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then(() => {
                Auth.currentSession().then(sess => {
                    const tokenId = sess.getIdToken().getJwtToken();
                    setToken(sess.getIdToken().getJwtToken())
                    setClinicianId(sess.getIdToken().payload.sub)
                    if (tokenId) {
                        async function getAssignedLabResults() {
                            try {
                                const getAssignedLabResults = await ApiService.getAssignedLabResults();
                                var lastURLSegment = history.location.pathname.substr(history.location.pathname.lastIndexOf('/') + 1);
                                const result = getAssignedLabResults.data.filter(data => data.kitId === lastURLSegment);
                                if(result !== null) {
                                    setAssignedTestResults(hideRelevantInfo(result, []));
                                }
                            } catch(ex) {
                                console.error(ex);
                            }
                        }
                        getAssignedLabResults().then(r => r);
                        async function getLicense() {
                            try {
                                setClinicianValidStates(validClinicianLicenseStates());
                                // const getLicense = await ApiService.getLicense();
                                // setClinicianState(getLicense.data[0].licenseState)
                            } catch(ex) {
                                console.error(ex);
                            }
                        }
                        getLicense();
                    }
                    setCustomerId(tokenId);
                });
            }).catch(err => {
            console.error(err);
        });
    }, []);

    function submitNotes(noteType, notes) {
        setBackdropOpen(true);
        async function putTestResultNotes() {
            try {
                // eslint-disable-next-line no-unused-vars
                const putTestResultNotes = await ApiService.putTestResultNotes(noteKitId, {"noteType": noteType, "notes": notes});
                setBackdropOpen(false);
                handleSnackOpen('Note Submitted!', "success")
            } catch(err) {
                console.error(err);
                setBackdropOpen(false);
                handleSnackOpen(err.message, "error")
            }
        }
        putTestResultNotes();
    }

    function releaseNotes(kitId) {
        setBackdropOpen(true);
        document.getElementById("release-" + kitId).disabled = true;
        async function putTestResultNotes() {
            try {
                // eslint-disable-next-line no-unused-vars
                const putTestResultNotes = await ApiService.putTestResultNotes(noteKitId);
                window.location.reload();
                setBackdropOpen(false);
                handleSnackOpen('Note(s) Released!', "success")
            } catch(err) {
                console.error(err);
                setBackdropOpen(false);
                handleSnackOpen(err.message, "error")
            }
        }
        putTestResultNotes();

        async function putTestResultNotesRelease() {
            try {
                // eslint-disable-next-line no-unused-vars
                const putTestResultNotesRelease = await ApiService.putTestResultNotesRelease(noteKitId);
                window.location.reload();
                setBackdropOpen(false);
                handleSnackOpen('Note(s) Released!', "success")
            } catch(err) {
                console.error(err);
                setBackdropOpen(false);
                handleSnackOpen(err.message, "error")
            }
        }
        putTestResultNotesRelease().then(r => r);
    }

    function appointmentRequest(kitId) {
        setBackdropOpen(true);
        document.getElementById("appointmentRequest-" + kitId).disabled = true;
        async function postAppointment() {
            try {
                // eslint-disable-next-line no-unused-vars
                const postAppointment = await ApiService.postAppointment({"testResultId": kitId});
                window.location.reload();
                setBackdropOpen(false);
                handleSnackOpen('Appointment Requested!', "success")
            } catch(err) {
                console.error(err);
                setBackdropOpen(false);
                handleSnackOpen(err.message, "error")
            }
        }
        postAppointment().then(r => r);
    }

    const handleInternalClose = () => {
        setShowInternal(false);
    }
    const handleInternalShow = (kitId, externalNote, status) => {
        setNoteKitId(kitId);
        setNoteText(externalNote);
        'RESULTS_RELEASED' === status ? setIsReadOnly(true) : setIsReadOnly(false);
        setShowInternal(true);
    }

    const handleExternalClose = () => {
        setShowExternal(false);
    }
    const handleExternalShow = (kitId, externalNote, status) => {
        setNoteKitId(kitId);
        setNoteText(externalNote);
        'RESULTS_RELEASED' === status ? setIsReadOnly(true) : setIsReadOnly(false);
        setShowExternal(true);
    }

    const handleAddressessClose = () => {
        setShowAddressDetails(false);
    }

    const handleAddresseeShow = (patient) => {
        setSelectedPatient(patient);
        setShowAddressDetails(true);
    }

    function processInternalNotes(event) {
        handleInternalClose();
        event.preventDefault();
        const numels = document.getElementsByName("internalNotesText").length;
        const notes = document.getElementsByName("internalNotesText")[numels - 1].value;
        submitNotes("internal", notes);
    }

    function processExternalNotes(event) {
        handleExternalClose();
        event.preventDefault();
        const numels = document.getElementsByName("externalNotesText").length;
        const notes = document.getElementsByName("externalNotesText")[numels - 1].value;
        submitNotes("external", notes);
    }

    if (assignedTestResults) {
        return (
            <>
                <Container fluid>
                    <Row>
                        <MaterialTable
                            title="Lab Results"
                            columns={[
                                { 
                                    title: 'Patient Name',
                                    field: 'user.name',
                                    render: rowData => (
                                        <a href="#"
                                        onClick={() => handleAddresseeShow(rowData.user)}>{rowData.user?.name}</a>
                                    ),
                                    cellStyle: {
                                        width: 150,
                                        minWidth: 150
                                    },
                                        headerStyle: {
                                        width: 150,
                                        minWidth: 150
                                    }, 
                                },
                                {
                                    title: 'Preferred Name',
                                    field: 'user.preferredName',
                                    cellStyle: {
                                        width: 150,
                                        minWidth: 150
                                    },
                                    headerStyle: {
                                        width: 150,
                                        minWidth: 150
                                    },
                                },
                                { 
                                    title: 'Patient Email',
                                    field: 'user.email',
                                    cellStyle: {
                                        width: 150,
                                        minWidth: 150
                                    },
                                        headerStyle: {
                                        width: 150,
                                        minWidth: 150
                                    }, 
                                },
                                { 
                                    title: 'Kit ID',
                                    field: 'kitId',
                                    cellStyle: {
                                        width: 150,
                                        minWidth: 150
                                    },
                                        headerStyle: {
                                        width: 150,
                                        minWidth: 150
                                    }, 
                                },
                                { title: 'Results Status', field: 'status' },
                                { 
                                    title: 'Clinician',
                                    field: 'clinician.firstName',
                                    render: rowData => {
                                        if(rowData.clinician !== null) {
                                            return <span>{rowData.clinician.firstName} {rowData.clinician.lastName}</span>
                                        } else {
                                            return <span>Unassigned</span>
                                        }
                                    },
                                    cellStyle: {
                                        width: 150,
                                        minWidth: 150
                                    },
                                        headerStyle: {
                                        width: 150,
                                        minWidth: 150
                                    }, 
                                },
                                { 
                                    title: 'Lab Date', 
                                    field: 'createDateTime',
                                    render: rowData => (
                                        moment.unix(rowData.createDateTime).format("LLLL")
                                    ),
                                    cellStyle: {
                                        width: 150,
                                        minWidth: 150
                                    },
                                        headerStyle: {
                                        width: 150,
                                        minWidth: 150
                                    },
                                },
                                { 
                                    title: 'Results',
                                    field: 'result',
                                    render: rowData => (
                                        <div>
                                        {rowData.results.map(result => (
                                            <div>{result.testName} : {result.result}</div>
                                        ))}
                                        </div>
                                    ),
                                    cellStyle: {
                                        width: 420,
                                        minWidth: 420
                                    },
                                        headerStyle: {
                                        width: 420,
                                        minWidth: 420
                                    },
                                },
                                { title: 'Patient Sex at Birth', field: 'user.genderAtBirth' },
                                { 
                                    title: 'Patient DOB',
                                    field: 'user.dob',
                                    render: rowData => (
                                        <>
                                            <div>{format_yyyy_mm_dd_to_DATETIME_MED(rowData.user?.dob)}</div>
                                            <div>{getAgeInYrsMonthsDisplay(rowData.user?.dob)}</div>
                                        </>
                                    )
                                },
                                { 
                                    title: 'Phone Number',
                                    field: 'user.phoneNumber',
                                    render: rowData  => formatUSMobileNum(rowData.user?.phoneNumber),
                                    cellStyle: {
                                        width: 170,
                                        minWidth: 170
                                    },
                                        headerStyle: {
                                        width: 170,
                                        minWidth: 170
                                    },
                                    filtering: false
                                },
                                { title: 'Allergies', field: 'user.allergies', filtering: false },
                                { title: 'Current Medications', field: 'medications', filtering: false },
                                { title: 'Current Symptoms', field: 'symptoms', filtering: false },
                                { title: 'Patient State', field: 'user.address.region' },
                                { title: 'Product Name', field: 'productName' },
                            ]}
                            actions={[
                                (rowData) => {
                                    if(clinicianValidStates?.length && clinicianValidStates?.includes(getRegion(rowData.user)) && (rowData.clinician === null || clinicianId === rowData.clinician.userId)) {
                                        if (rowData.status !== 'RESULTS_RELEASED' && rowData.status !== 'COMPLETE') {
                                            if (rowData.clinician == null && rowData.status === 'NEEDS_CLINICIAN_REVIEW') {
                                                return
                                            } else {
                                                return { 
                                                    icon: () => <NoteAdd id={"internal-" + rowData.kitId} name={"internal-" + rowData.kitId}  />,
                                                    tooltip: 'Add Internal Note',
                                                    onClick: () => 
                                                        handleInternalShow(rowData.kitId, rowData.internalNotes, rowData.status)
                                                }
                                            }
                                        } else {
                                            return { 
                                                icon: () => <NoteAdd id={"internal-" + rowData.kitId} name={"internal-" + rowData.kitId}  />,
                                                tooltip: 'View Internal Note',
                                                onClick: () => 
                                                    handleInternalShow(rowData.kitId, rowData.internalNotes, rowData.status)
                                            }
                                        }
                                    } else {
                                        if (rowData.status !== 'RESULTS_RELEASED' && rowData.status !== 'COMPLETE') {
                                            if (rowData.clinician == null && rowData.status === 'NEEDS_CLINICIAN_REVIEW') {
                                                return { 
                                                    icon: () => <NoteAdd className="gray-button" id={"assign-" + rowData.kitId} />,
                                                    tooltip: 'license ineligible',
                                                    disabled: true,
                                                }
                                            } else {
                                                return { 
                                                    icon: () => <NoteAdd className="gray-button" id={"internal-" + rowData.kitId} name={"internal-" + rowData.kitId}  />,
                                                    tooltip: 'license ineligible',
                                                    disabled: true,
                                                }
                                            }
                                        } else {
                                            return { 
                                                icon: () => <NoteAdd className="gray-button" id={"internal-" + rowData.kitId} name={"internal-" + rowData.kitId}  />,
                                                tooltip: 'license ineligible',
                                                disabled: true,
                                            }
                                        }
                                    }
                                },
                                (rowData) => {
                                    if(clinicianValidStates?.length && clinicianValidStates?.includes(getRegion(rowData.user)) && (rowData.clinician === null || clinicianId === rowData.clinician.userId)) {
                                        if (rowData.status !== 'RESULTS_RELEASED' && rowData.status !== 'COMPLETE') {
                                            if (rowData.clinician == null && rowData.status === 'NEEDS_CLINICIAN_REVIEW') {
                                                return 
                                            } else {
                                                return { 
                                                    icon: () => <Message id={"external-" + rowData.kitId} name={"external-" + rowData.kitId}  />,
                                                    tooltip: 'Add Notes for Patient',
                                                    onClick: () => 
                                                        handleExternalShow(rowData.kitId, rowData.internalNotes, rowData.status)
                                                }
                                            }
                                        } else {
                                            return { 
                                                icon: () => <NoteAdd id={"external-" + rowData.kitId} name={"external-" + rowData.kitId}  />,
                                                tooltip: 'View Notes for Patient',
                                                onClick: () => 
                                                    handleExternalShow(rowData.kitId, rowData.internalNotes, rowData.status)
                                            }
                                        }
                                    } else {
                                        if (rowData.status !== 'RESULTS_RELEASED' && rowData.status !== 'COMPLETE') {
                                            if (rowData.clinician == null && rowData.status === 'NEEDS_CLINICIAN_REVIEW') {
                                                return 
                                            } else {
                                                return { 
                                                    icon: () => <Message className="gray-button" id={"external-" + rowData.kitId} name={"external-" + rowData.kitId}  />,
                                                    tooltip: 'license ineligible',
                                                    disabled: true,
                                                }
                                            }
                                        } else {
                                            return { 
                                                icon: () => <NoteAdd className="gray-button" id={"external-" + rowData.kitId} name={"external-" + rowData.kitId}  />,
                                                tooltip: 'license ineligible',
                                                disabled: true,
                                            }
                                        }
                                    }
                                },
                                (rowData) => {
                                    if(clinicianValidStates?.length && clinicianValidStates?.includes(getRegion(rowData.user)) && (rowData.clinician === null || clinicianId === rowData.clinician.userId)) {
                                        if (rowData.status !== 'RESULTS_RELEASED' && rowData.status !== 'COMPLETE') {
                                            if (rowData.clinician == null && rowData.status === 'NEEDS_CLINICIAN_REVIEW') {
                                                return 
                                            } else if (rowData.status !== 'NEEDS_CONSULT') {
                                                return { 
                                                    icon: () => <AssignmentInd id={"appointmentRequest-" + rowData.kitId} name={"appointmentRequest-" + rowData.kitId}  />,
                                                    tooltip: 'Appointment Request',
                                                    onClick: () => 
                                                        appointmentRequest(rowData.kitId)
                                                }
                                            }
                                        } else {
                                            return
                                        }
                                    } else {
                                        if (rowData.status !== 'RESULTS_RELEASED' && rowData.status !== 'COMPLETE') {
                                            if (rowData.clinician == null && rowData.status === 'NEEDS_CLINICIAN_REVIEW') {
                                                return 
                                            } else if (rowData.status !== 'NEEDS_CONSULT') {
                                                return { 
                                                    icon: () => <AssignmentInd className="gray-button" id={"appointmentRequest-" + rowData.kitId} name={"appointmentRequest-" + rowData.kitId}  />,
                                                    tooltip: 'license ineligible',
                                                    disabled: true,
                                                }
                                            }
                                        } else {
                                            return
                                        }
                                    }
                                },
                                (rowData) => {
                                    if(clinicianValidStates?.length && clinicianValidStates?.includes(getRegion(rowData.user)) && (rowData.clinician === null || clinicianId === rowData.clinician.userId)) {
                                        if (rowData.status !== 'RESULTS_RELEASED' && rowData.status !== 'COMPLETE') {
                                            if (rowData.clinician == null && rowData.status === 'NEEDS_CLINICIAN_REVIEW') {
                                                return 
                                            } else if (rowData.externalNotes) {
                                                return { 
                                                    icon: () => <AssignmentReturned id={"release-" + rowData.kitId} name={"release-" + rowData.kitId}  />,
                                                    tooltip: 'Send Results',
                                                    onClick: () => 
                                                        releaseNotes(rowData.kitId)
                                                }
                                            }
                                        } else {
                                            return
                                        }
                                    } else {
                                        if (rowData.status !== 'RESULTS_RELEASED' && rowData.status !== 'COMPLETE') {
                                            if (rowData.clinician == null && rowData.status === 'NEEDS_CLINICIAN_REVIEW') {
                                                return 
                                            } else if (rowData.externalNotes) {
                                                return { 
                                                    icon: () => <NoteAdd className="gray-button" id={"release-" + rowData.kitId} name={"release-" + rowData.kitId}  />,
                                                    tooltip: 'license ineligible',
                                                    disabled: true,
                                                }
                                            }
                                        } else {
                                            return
                                        }
                                    }
                                },
                            ]}
                            data={assignedTestResults} 
                            options={{
                                filtering: false,
                                exportButton: true,
                                search: true,
                                pageSize: 50,
                                pageSizeOptions : [50, 100, 200],
                                emptyRowsWhenPaging: false,
                                actionsColumnIndex: -1,
                                draggable: false
                            }}
                        />
                    </Row>
                </Container>
                <Modal show={showInternal} onHide={() => handleInternalClose()} backdrop={'static'}>
                <Modal.Header closeButton>
                    <Modal.Title>Internal Notes</Modal.Title>
                </Modal.Header>
                <Form onSubmit={processInternalNotes}>
                    <InputGroup>
                        <FormControl name={"internalNotesText"} as="textarea" rows="20"
                                        cols="120"
                                        aria-label="With textarea" disabled={isReadOnly}>
                            {noteText}
                        </FormControl>
                    </InputGroup>
                </Form>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleInternalClose}>
                        Close
                    </Button>
                    {
                        isReadOnly ? "" :
                            <Button variant="primary" onClick={processInternalNotes} type={'submit'}>
                                Save Changes
                            </Button>
                    }
                </Modal.Footer>
            </Modal>
            <Modal show={showExternal} onHide={handleExternalClose} backdrop={'static'}>
                <Modal.Header closeButton>
                    <Modal.Title>Notes to Patient</Modal.Title>
                </Modal.Header>
                <InputGroup>
                    <FormControl id={"externalNotesText"} name={"externalNotesText"} as="textarea" rows="20"
                                    cols="120"
                                    aria-label="With textarea" disabled={isReadOnly}>
                        {noteText}
                    </FormControl>
                </InputGroup>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleExternalClose}>
                        Close
                    </Button>
                    {
                        isReadOnly ? "" :
                            <Button variant="primary" onClick={processExternalNotes} type={'submit'}>
                                Save Changes
                            </Button>
                    }
                </Modal.Footer>
            </Modal>
            <PatientProfileModal show={showAddressDetails}  onHideModal={() => handleAddressessClose()} user={selectedPatient}/>
            <Backdrop className={classes.backdrop} open={backdropOpen}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={handleSnackClose} severity={snackSeverity}>
                    {snackText}
                </Alert>
            </Snackbar>
        </>
        )
    } else {
        return (
            <Container fluid>
                <Row>
                    <div>Please wait. Loading...</div>
                </Row>
            </Container>
        )
    }
}

export default UserResult